var _style, _g, _g2, _g3, _g4, _g5, _g6, _ellipse, _polygon, _polygon2, _ellipse2, _defs, _g7, _ellipse3, _polygon3, _polygon4, _ellipse4, _defs2, _g8, _ellipse5, _polygon5, _polygon6, _ellipse6, _polyline, _path, _path2, _ellipse7, _polyline2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonCompletedDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 69.3 63.3",
    style: {
      enableBackground: "new 0 0 69.3 63.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{opacity:0.3;fill:#52656D;enable-background:new    ;}\r\n\t.st1{fill:#37464F;}\r\n\t.st2{fill:#5F7888;}\r\n\t.st3{fill:#6F8B9D;}\r\n\t.st4{fill:#4F6471;}\r\n\t.st5{fill:#C4C4C4;}\r\n\t.st6{fill:#375161;}\r\n\t.st7{fill:#293D49;}\r\n\t.st8{opacity:0.92;fill:#293D49;enable-background:new    ;}\r\n\t.st9{fill:#2A3E4A;}\r\n\t.st10{fill:#C77D07;}\r\n\t.st11{fill:#CD7D04;}\r\n\t.st12{fill:#FFC511;}\r\n\t.st13{fill:#FFC616;}\r\n\t.st14{fill:#FFC903;}\r\n\t.st15{fill:#FEF504;}\r\n\t.st16{fill:#EDAA04;}\r\n\t.st17{fill:#EFAD06;}\r\n\t.st18{fill:#C27703;}\r\n\t.st19{fill:#975900;}\r\n\t.st20{fill:#B66F03;}\r\n\t.st21{opacity:0.92;fill:#975900;enable-background:new    ;}\r\n\t.st22{opacity:0.92;fill:#B66F03;enable-background:new    ;}\r\n\t.st23{fill:#BE740B;}\r\n\t.st24{opacity:0.3;fill:#AFAFAF;enable-background:new    ;}\r\n\t.st25{fill:#CE7D03;}\r\n\t.st26{fill:#EEAB00;}\r\n\t.st27{fill:#B46C00;}\r\n\t.st28{fill:#724500;}\r\n\t.st29{fill:#FEC700;}\r\n\t.st30{fill:#FEF400;}\r\n\t.st31{opacity:0.3;fill:#CE7D03;enable-background:new    ;}\r\n\t.st32{fill:#BF7402;}\r\n\t.st33{fill:#2C383F;}\r\n\t.st34{opacity:0.2;}\r\n\t.st35{clip-path:url(#SVGID_2_);}\r\n\t.st36{fill:#FFFFFF;}\r\n\t.st37{fill:#168DC5;}\r\n\t.st38{fill:#1CB0F6;}\r\n\t.st39{clip-path:url(#SVGID_4_);}\r\n\t.st40{fill:none;stroke:#FFFFFF;stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st41{opacity:0.2;fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 425,
    height: 431,
    id: "XMLID_2_",
    xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEASABIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAiwAAAQWgAAHov/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAbABqgMBIgACEQEDEQH/ xADPAAEAAwEBAQEAAAAAAAAAAAAAAgMEBQEGBwEBAQADAQEAAAAAAAAAAAAAAAECBAUDBhAAAQQB AwMCBgEEAwEAAAAAAgABAwQFQBEUMBI1EBMgUCExMwYiYDIVFnAjNCURAAECAgYHBQYFBAMBAAAA AAEAAhEDITHRkgQ0EEBBURKyc2FxIjKEIDCBkbETUKHBQlLwYnIjMxQFghIAAQMCBQEFBgQHAAAA AAAAAQARAiESQDFBUQMQYXGBIjJgkaFighNwsVKS8MHRQnIEFP/aAAwDAQACEQMRAAAA+ey2ZMsL 1AvUC9QL1AvUC9QL1AvUC9QL1AvUC9QL1AvUC9QL1AvUC9QL1AvUC9QL1AvUC9QL1Av28vcQya8g AAAAAAAAAAAAAAAAAAAAAAAAA3YdxDJryAAAAAAAAAAkRWipaKloqWipKIAAAAAAAAAA3YdxDJry AAAAAAAAAC2uZWltywwOjXljiabpcDpc6W2m2rHMAAAAAAAAABuw7iGTXkAAAAAAAAAPZwmO3wJe njv08ZZ3a+Myx6PN988va2q2rHMAAAAAAAAABuw7iGTXkAAAAAAAAAF1NxS6Wasy+xMjXUUtWhcd NtUAAAAAAAAAAN2HcQya8gAAAAAAAABLfVCyPY09De5kPZW7WlTDRWcTlfYczV3uXz9Puj08ggAA AAAAAABuw7iGTXkAAAAAAAAHvkzfD2718foh1eFq7tXY53Y5XD+x4dx4I6HK+UslHk93nPfPP1AA AAAAAAAbsO4hk15AAAAAAAABKI6Mo0enl9cz6Orw9303xvuvtfZfKUeVHz3N76vAlnu5PdweGHoA AAAAAAAA3YdxDJryAAAAAAAAAGi3FurR1/npbOl9LPj6NvR6EMWc38ahqb/tF2LW3AgAAAAAAAAB uw7iGTXkAAAAAAAAAHvg13c6VaIezK5+wNNGeIEAAAAAAAAAAN2HcQya8gAAAAAAAPTxptMLfGsS +iAAAAAAAAAAAAAAG7DuIZNeQAAAAAAAnuhbYej1tmc6jdnOY0Z5QAAAAAAAAAAAAG7DuIZNeQAA AAAAA6ZKzZXoglN2S1ZZJwKcW3EoQAAAAAAAAAAAA3YdxDJryAAAAAAAG63FprbPGS2oDyorzSjK AAAAAAAAAAAAA3YdxDJryAAAAAAAC6kbJYpGzzLGtOeCAAAAAAAGrofZa2z8U+yjpbXx762+PgsP 6d8tu6/zQ2tQABuw7iGTXkAAAAAAACYg98AAAAAAAAAP0DQlw+zSOdstFst7whXfHZw/L/LK+txw AG7DuIZNeQAAAAAGk80y22YnQqMlPXwnLj0efL4AAAAAA7HNKfofnt8v6PLy7S6OSe+EZ2ifpjkh fVhn838X1uTu84LiA3YdxDJryAAAAAHvRwdCruryurcZxlElh3YTn5dWeXIJQAAAAOh3vkfqpfnd /wCjfM3H6K+mevu6uH0efljbu5nQLKpeeft+dcj6H57d5AYe4Ddh3EMmvIAAAAAS6HN21r2831Op 7y52b8+RL5mvxrUIAAAAAdXlD9Xw/E/X56/T0cnZMtVE5avSrujAtohm3OTHhdfqZef55zPsPj9f ohlg3YdxDJryAAAAACysbbMF1avc/pdCqoszEAAAAAAAOnzJn2/R+T7nQ4vTnil5926MYz2t57h+ /wAzzp4q+Z3gsAbsO4hk15AAAAAAAAAAAAAAAAABfRYbPtPkPrsvT2vfj9uzL2G2zJ8V9b8vr8bF nvomAADdh3EMmvIAAAAAAAHuwzW6lmeGsc6PTyrmEAAAAAAbuhwbj9X2/kGyZfpOH4LJcuhlzUPM AABuw7iGTXkAAAAAAANl/ntiV1pDLvrMiysxU7cUoAAAAAAAAAAAADdh3EMmvIAAAAAAPfB00J2W a8Ww9j54mXwWnFqyygAAAAAAAAAAAAN2HcQya8gAAAAAABo08/RWr2mSTlV4WVxoWNZAAAAAAAAA AAAADdh3EMnRylC8ULxQvFC8ULxQvFC8ULxXP0IyFUbxQvFC8ULxQvFC8ULxQvFC8ULxQvFC8ULx QvFC8UbqNp//2gAIAQIAAQUA/pwQJ29o00ZOxAQ6iORhYZe1e/8AQi7tTs+2ztqYKzMz9rN9Haes 22mhZnlVmaXetNLupWZpNLGXabPupq/unDXeI3fZjfuPTRWO1DKzopmZTWO75lt84f57PaaNyyjs 0eTM3htd76e6xdqhrdqZvrpnZyb223apEL+0yIGQi4t0W6bvs0B90hNsbm2zG2227yM7HpNmdB2R lLXI08RsmiN1BUJntSB2A7u2lFwaNyJ3EzYu4WDZt9MBuKEn7f4ixG5anZO7u39Y/wD/2gAIAQMA AQUA/pwpBF/fjTygxBIJ6iWJzc4O5NW+oB26nuZnYmd9RZuE7t3ET9wlWuFvprBOMKp14drleFmU BOUWlmHujdnZ69toYrFtpoxF3eIe2PTT1O5ygJkMBEoKvY//ABNBWeRmoAioRspqva2ng2ZkUm6d /p1N1v0N0xiDse48h3TyszsTozE36T9IRcivRMFaF+6FoX7nhfu+w1iYoenstuhu7KZprAVrwQIL MJMdmEWvZUCDF15mlkEWLSbI60stiDBQRDYwdWQGqSDMzuw6VlC4BNCTmJjEAyOJTPqGJ2RSkQ/1 j//aAAgBAQABBQDKXbg5PnXVzrq511c66uddXOurnXVzrq511c66uddXOurnXVzrq511c66uddXO urnXVzrq511c66uddXOurnXVzrq511c66uddXOurnXVzrq511c66uddXOurnXVzrq511c66uddXO urnXVzrq511c66uddXOurnXVzrq511c66ubcWV8p81yvlPmuV8p81yvlPmuV8ppAjI1xzXHNcc1x zXHNcc1xzXHNEBBqMr5TRt95icX6ETubafK+U0bfex+aMCkOfGDCMWLilhq44rU9akc9ubGMELYq F4TZhOv+XT5Xymjb72PzV+/35IWmCi7NjKHtVsewRhm5pIXx0bt/hFX/AC6fK+U0bfex+ZPIbtu7 M7u7d5ruJm3fZV/y6fK+U0bKYXPoxM8bafK+U0lcZCJxBmksAyCWY3mqTe3HUnGMpZgeOxGS7Rdp xkEtPlfKaOMHkJmGMCKWzJSwAC0cMMTGAmIiIDLXhma9gB2jkkgMwGUDFwLTZXymjqx9oWpHIsVj hqQ+latNalnglry+mYxw2Iqsitx7jpsr5TRM27/QAxELWMh6Q4u9OOHxp0wzOMktqfG3YA9MhFxc iYsQabK+U0UX5Zvxfrv/AKvTD5UJR9M1lQYfTP8A/vD6gf0PS5XymijfY5G3jwR9lr7+mGj9zIz2 YK4w2IbAZSP276d2Zs0ffeFu0CfctLlfKaOIu+OvJxbsEzbKOWSI5ZpZiinmgIzOQ1YnbYz5Nyc+ yPTZXymjqSbPYi7xxuQbYJiBDYB00gOnkBkVgGUkpEslfY1BF7YWpO4tNlfKaNndngmaRp6/cq+S nrqLJ1JGaeEkViAVLlKsbWMhYtPBXYFYnYG0+V8ppGd2eK0zogjkYqbJ6kqapKhpshEI2ltMnd3f T5XymmCUwQ3CZcwVzBRWzdFIZ6rK+U+a5XymgESJwpumrRMvYhRVYnUlUx+QZXynXjjeQo4xjb0E DJmjN07bKeBjZ2dn1uV8p168fZGmF3W2yqe2QgwMdqNmJW49i1uV8p1m+7NsyqAIq1D/ACiB42Ux iwK03/Trcr5TrN92fdo3YTIgeNTd7HFOPbKbGatP/wBWtyvlOvEe7KGVu1po95zEn9HfZrJ7trcr 5TrwybIT2TOz/A5MyM1IfeWtyvlNBHNsmJnXcS7yTk7opBFSSOegq4u9cZv1fLr/AFfLL/V8sv8A V8urOFyVUejlfKaFndk00jL35E8hvof13DjflEY4gedHI5Ld2URuTOzO37LhI4g6GV8p8lwNdocT O/8AP0ZndQxuLbKzCM1cmcX+PK+U633TRSOvZlZOJNpMW3/zrAOxJm3eMO0dlsjb+E/0n+PK+U6s VVyQxgHq7M6kqgSMCB9B+nUatq64szvAJC+PHeOmAL2mXtMvaZOP1/c8fTGl8eV8p1K0O/pXoNLG eMbaGhJI/wDjAUsRRSSRjIJC4l1MVgwv1rVaWpOsKdsciO7iyGnITSwnEooTlR1JBZOy/YbuQnvf HlfKdMW3IWYWrMznD+JB6W2Z3VwNi6mIyh0JstQjyVR8feYP1hm/ysbbhDs0l/IV6VTAZ+zlY87m yxVDBZQsjjZtvdJl+0MzZb48r5Tpw/lVb++H8SD0t/dXP7Or+klJLNsztPjI6n7FA+8SsQwWIKeP q4qvcx9XKwRRQQQIvo37VRmaz8eV8p04/oYvu1cmYwnIGayW72Nm5JqY2cFbLdur+u5N8dkeZB2z z+6dSVnD0AJOySOT2/SzKzDLGEof6S8pZjA28S/w5XynTb6PFJ9GfdbuhMhc5zJt3W6MtlOW5dbH 525VcSExiJ2cLbsmsROvdjXuxp7ETI7TuiJ2bGXYsnGJw1h/ccrUlrfDlfKdSKTscSTSMu4Vuycx ZPI7qWVhbQUM9aphj8jHOKCIzaZ6o1gNniYmf0yF8AjoZOxjbuazM2Xn+LK+U6oSECGcXTGLruFP KDI53dffQxB3lXlEwxHudtm2Vh2YWCOUo0z7PmY7ESnnGNpxYZPjyvlPklZ/qBkBUhEsKUYuzsUS Ymce7+OW2D9fIiMrTbP8eV8p8krn2S9o7/qM0VipZoWIHkchEA7VSonZf9xtxsu0d7Z90vx5Xymh CCQ01NcMUVMmRxmGgrWGJqN2ajZxmbpZKMoYSVzHjM+V/YKWMhnmksS2LDRs7u7/AB5XynXEXJ4a 4h8LsztPW20AWpQQ5CUXi/aMvEM37HlLDc80duUk7u79DK+U69WLYfSMe8pYhcPWzH2Hrcr5TrN9 xbYVHALiEYB6PBG6mjaN1bbeLW5XynWb7t9lFK4P6SH2CROTq1+HW5XynXiLdlG25u7MwzRk8zbx +lotx1uV8p14D3YTZ/RyIvRzJ232RHupj7i1uV8p12d2eOViTE7L3HXuJ5HTkpJt9flfKaEZTFNY XIZPYdEZF8gylK4WT4N1cG6uDdXBurg3Vwbq4N1cG6uDdXBurg3Vwbq4N1cG6uDdXBurg3Vwbq4N 1cG6uDdXBurg3Vwbq4N1cG6uDdXBurg3Vwbq4N1cG6uDdXBurg3Vwbq4N1cG6uDdXBurg3Vwbq4N 1cG6uDdXBurg3Vwbq4N1cG6uDdXBurhXF//aAAgBAgIGPwD2cJAoEKerKqJAoP5IPr24ggi59NEK OYxMR4lECLXGR/dso/LG3EuycjEiUw5OmyLsAPctCD7kZcYYjTDwB36HjkBEdmoQ44gSA+A6TA/U cNGWx6CRk0QGbVEiTxIbt6SlucPbLwKoQVUgK2OWp/Ce0VIzfIKlsvBWmMQVbMMTkRiJH569BIly 2WyGHYZlSEg9WVw4wE9qDBMc8K6iG1Uv8ii+yDbLxRfC1Qlxu7Vu0X3OMerOPb2KsZDwVIyPghPk o1RFC0gyfTZOcMJDJvigfS1VJ2Z6K8mifXDs/ld2RJIOfp2ROQz96Z6O7YoA6e2X/9oACAEDAgY/ APZwAmpUi7WepwQyESalvjkjacs6EYgEG1tdVLzMJzEzTYMyiTJ7REd9p1UqvdK7EsSHTAjEmHEb Yj+4ZlBnMiabui7iQPi6EOUuDQS1Hfh5kfp6R5YEzLa6HuUuWUjGR21Pd0gTmYjDTjvHoYiLyMnc 5KMTG2UZO+iZQjtEYcyhrnH+irGQVIyKEp5jKP4T3SLDRsys5e9O8ldAuBmDiIj5R0YYi+XpjUqM o6gFW3umMlVXRyIwoA1XJJ6WHNcfbxx/JRbdF913BQILsGPfhXBY6FS4v9m0REgYnio/e6/5uct9 ukOTQx0fuXl5OM/UF5uTjH1BHi4DdfSU8g3YpXwlHitrdQE6MiI5YY8YeXJKTVQ++Zc0ptEiIoP4 3RHHH7MojySiX/cCvtSHnjJmVr0w8eUisaPqxTmUJVLGO2j9qeVIiV/1ZqfKAxn+WJpRCJNI5e2X /9oACAEBAQY/AMY1uImACfNAAe6AHGe1ZibfdasxNvutWYm33WrMTb7rVmJt91qzE2+61Zibfdas xNvutWYm33WrMTb7rVmJt91qzE2+61ZibfdasxNvutWYm33WrMTb7rVmJt91qzE2+61ZibfdasxN vutWYm33WrMTb7rVmJt91qzE2+61ZibfdasxNvutWYm33WrMTb7rVmJt91qzE2+61ZibfdasxNvu tWYm33WrMTb7rVmJt91qzE2+61ZibfdasxNvutWYm33WrMTb7rVmJt91qzE2+61ZibfdasxNvutW Ym33WrMTb7rVmJt91qzE2+61ZibfdasxNvutWYm33WrMTb7rV/zzMtHzur+axvXm87vxX0qxvXm8 7vxX0qxvXm87vxX0qxvXm87vxX0qxvXm87tV8Io3qtvzVbfmq2/NVt+arb81W35qtvzVbfmvENX9 Ksb15vO7VftNoDa+0+5Mp1IIiOwjV/SrG9ebzu1QJ39bE2W2lzjAd5T4z2GZLEXS9qM4YlvCwAvo PhipkqU8FksR+5sK/wCqTwOHECT/AGp86VObNbLMJkP2ozxim/bBgXQNac0HiAJAO9DuP01f0qxv Xm87tUCd/WxS/tkNfxDhJqBU12OkslkNiJzTWVjQTSeH9UHvmiS+c8ODjuaakycwgy5zHPB/+SsQ cI3gJfCcCYmEawpojT9wUfLQO4/TV/SrG9ebzu1QJ39bNEC4kbiUQDQawgCaBUEDxGIqpRAJga1C NG7QO4/TV/SrG9ebzu1X7raQa+w+5Mx1FEGjeTq/pVjevN53ar4TBu0qJA71CW0HtgoMYHHsbFfd MssO0EL7olF5NUBEBQc0NPa2Cg9oB3woVAHYYLxmI2HV/SrG9ebzu1QNChUAhLlgmNTRtQfijxO/ gKh3qEtgaBuC4XiIOwoNaIAVAKE1gcDvCMzCGBr+2f0RlzQRCgg1hQNRqKLTWNW9Ksb15vO7VOI1 u+iEpvx70HvEZzxFx3DdpEqSIuNPYjKmjhe2saTOliE5gj/kNy+27ZUg8Vig6t6VY3rzed2pgb12 NCaXUhsXn4VaQ9ko8LqiaE584D7r6KKYBMmyAPutocDREIvmSiGCt1Y0vDaGx4h3FEbxq3pVjevN 53am3vCd3KZ0/wBRpZhZvhmNHCw7HAaX4OT4iaJjt3ZpH+DfqU3uCcO06r6VY3rzed2ptO4pw3hO O9v6hR0Sv7Yu+QiuKc8MHbWuOS8Pb2Kc3ZxR+dOiJqCj/aB9UBuCJ3nVfSrG9ebzu1QHeKUHHyxg e4oNJo2HQJktxa8VELjmuL3HaVxSnljt4KL3kuc6snQQDBopJTpn7Yx+ATjtqGrelWN683ndqn2z UalxDzBCROMCKGOP0W8blTQqCFS4KilUmA3L/ryDEHzOG3sVPmNa4BU2vv1b0qxvXm87tUiK1A+Y VriZQ7aFwTBxtGw1hUu4DucqJjfmFEzGj4rwnjO5q4GeFh2D9VxOpd9Fwt8x/LV/SrG9ebzu1WIo IUJlB3qkR7V4XfNUQKpgF4jHuVEAN64ZfzUTXq/pVjevN53av4TDsXiEV5SvKV4QAvEY6z6VY3rz ed34r6VY3rzed2owaIlReYdgVUe9eUKiIUW+Ia/6VY3rzed2ocI+JUGj46YgRCoFSgVxNod9VA16 76VY3rzed2oA7XUnRQIqlcLt0PioO8qLm0jQHjbXrvpVjevN53e/ChoAmCEVFlMDBEuMI7NBBrOz QewjXfSrG9ebzu9+FFAmpNgPENBDjHcoOMCFEVVaCO7XfSrG9ebzu1Abjo4XGBFShH4ocNMNumKh v130qxvXm87tQ4T8FAqj2YmgBR2bNd9Ksb15vO7UYO+aiCq9FapPwW4btQjh5LnN/lU35ryNvBeR t4LyMvBeRt4IumyHcArc2kfl7n0qxvXm87tSoMFXopOomfPEcPKNX8nbkGtAYxtAAoCoCooGimsK BpB2I47Ct4Wx/wBzBVT+4e49Ksb15vO78Gw7QIFzeN3aXGxQ2DTQoms6Jsp4i17SCO8ItNYMD7fp VjevN53ahQ0rylUgjVMN02/RcWw6IBAbdLu4qZ/k76+36VY3rzed3vuJ9A3bV4RppEVFvhP5KDhq Mx+IaHmS3iYw1RJhGCgBACoBQdSCqHEKMYneq1Wq1BNxbWtlz2uDYgQ4gdnt+lWN683nd737jvgN Ae9xbGoBeB9PajxnhAoXnPyTmHYa1A17Ci01j3rp75hZSWtApq3p0iaIOaa9436JIwjzLmOMC4fx 2xQJrIpQUSQ3sXiq3rw1b1EEO7NBUyRi38TZLj9toEGwNRh3e36VY3rzed3vAN6AFQR7Am6DomR/ qjQHb6D72DqZDz427u0IYjDwdNaOKW4fuG5fcMiZwDbwlMjWGu+ib3JpNQKfiJswNa0UGvxGqhYi Tig0vlAOa9ohERhUpYw7gMVMMWtI4gWg+IpmKngMmRLXQqJG1OLao6Hw2taT+ft+lWN683nd7xne NB7k3QdEzu/TQ3v99OlPPFJlt4mtOxxMFAijcmYiQzhlTZbnPAHha6r8009mgyZrQ5jhBwKmOwnE 504+J7tgBoAUt2L4mukE8Lm7QawU2TIaGMbUBoKGNaOKUQGuI/aRv9v0qxvXm87veN71FGO0KAIg qYELwj5qsJxJpOgDcffMef8Aim/65vcTX8FxB0dq4qhUEGE0irTQYAk+EjtRi6gftA08ArNadLmN DmOoIKc+TiAyWT4WuBJCaZpEyU+hsxtUdx9n0qxvXm87veRQOwqhVqIKhV3KvRAVqG737ZbnccmI BDqSB2FBzTFrhEHsKoUHiPaq4d68wXmCrj3KDBDtRcaYUpz5FDmGExhrabEGzJjWE0+IgfVMwUl7 ZswuDnFpiGgdvs+lWN683nd72BqKiDQqVWq9FFCgPNqIlECbLFQdWO4ofcAY9wBG6kR0RA8IrcaA pYY4OnRPGW0hP/18R/n/AB0ulSjF5ECRsRxMgxpIcw1ObGopkyYwS2ywQxo7a6fa9Ksb15vO731F W5U0KghVhVqDaO3UhuFaAbQWiBCdiJ8wjDSzANP73fxCDOKDCfKKAAqK9icG1OECCoqXNY8nDzhQ BRBwraoGlxRhUaR7fpVjevN53fgpbvpQLTArDTAKC5/F/kqQIFRFLNo3IQq3qH5pz3+YTQZY/Iou cYkpvbH2/SrG9ebzu/BWk1VH4qMFP/8AOm1g/cZvgaDDuRoL2bHBUNidyO47Ny4j4ZYMCVI/86TV K8bwNhqCjBQFTaPb9Ksb15vO7UqBAbyqXfJeYrwkFeIQ1AMeYOFR3pmJkmD2GrYRtBQLHhk6HjlO MCD2b14mNPwTDL4WBvmo2IycKWzMRCDWt8rTvcU+dNdxTHmLid6gKXn8lE1+36VY3rzed2oACklR dS72YERCLmVbRqEI8Q7VxNHCRUQSCuGXPe0buKP1UJ057hu4iPovKPmoDwjsUTX7j0qxvXm87tQ4 zWau7SB814RAir2Ijyu130qxvXm87tQA3DQCTWvCNEYQQga9Edx130qxvXm87vfjTA0t0xUTXoPe Nd9Ksb15vO7UPpoaO1RJgoAo/PTDXfSrG9ebzu1Dh2ipU16KTHRAmjdogKlAVDXfSrG9ebzu1CIr UDQdFSq0RJXC2rfr3pVjevN53alXEdqpCqVAVJ1/0qxjm4eYQZ80ghjoEcZ7Fl5tx1iy8246xZeb cdYsvNuOsWXm3HWLLzbjrFl5tx1iy8246xZebcdYsvNuOsWXm3HWLLzbjrFl5tx1iy8246xZebcd YsvNuOsWXm3HWLLzbjrFl5tx1iy8246xZebcdYsvNuOsWXm3HWLLzbjrFl5tx1iy8246xZebcdYs vNuOsWXm3HWLLzbjrFl5tx1iy8246xZebcdYsvNuOsWXm3HWLLzbjrFl5tx1iy8246xZebcdYsvN uOsWXm3HWLLzbjrFl5tx1iy8246xZebcdYsvNuOsWXm3HWLLzbjrFl5tx1iy8246xZebcdYsvNuO sX/BMy0PI6v5L//Z",
    transform: "matrix(1 0 0 1 171.3498 -629.4762)"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_146_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_43_",
    className: "st0",
    d: "M-175-346.8h72c2.2,0,4,1.8,4,4v32c0,2.2-1.8,4-4,4h-72c-2.2,0-4-1.8-4-4v-32 C-179-345-177.2-346.8-175-346.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_42_",
    className: "st1",
    d: "M-170.6-345c0-5.5,4.5-10,10-10h42.4c5.5,0,10,4.5,10,10v26.6c0,2.2-1.8,4-4,4h-54.5 c-2.2,0-4-1.8-4-4V-345z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_41_",
    className: "st1",
    d: "M-172.7-359.5c0-5.5,4.5-10,10-10h47.1c5.5,0,10,4.5,10,10v29.8h-67.2V-359.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_40_",
    x: -175.7,
    y: -342,
    className: "st2",
    width: 73.8,
    height: 11.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_39_",
    className: "st2",
    d: "M-111.8-359.3h7.9c1.1,0,2,0.9,2,2v18.3h-9.9V-359.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_38_",
    className: "st2",
    d: "M-175.7-357.3c0-1.1,0.9-2,2-2h6.4c1.1,0,2,0.9,2,2v16.3c0,1.1-0.9,2-2,2h-6.4 c-1.1,0-2-0.9-2-2V-357.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_37_",
    className: "st2",
    d: "M-172.7-370.8c0-1.1,0.9-2,2-2h10.5c1.1,0,2,0.9,2,2v20.5h-14.5V-370.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_36_",
    className: "st2",
    d: "M-120.1-370.8c0-1.1,0.9-2,2-2h10.5c1.1,0,2,0.9,2,2v20.5h-14.5V-370.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_35_",
    className: "st3",
    d: "M-172.6-360.6l14.3-3.6v12.6l-14.3-0.2V-360.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_34_",
    className: "st4",
    d: "M-172.7-353h14.5v14.5h-14.5V-353z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_33_",
    className: "st4",
    d: "M-172.7-332.2c0-1.1,0.9-2,2-2h10.5c1.1,0,2,0.9,2,2v17.8c0,1.1-0.9,2-2,2h-10.5 c-1.1,0-2-0.9-2-2V-332.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_32_",
    className: "st4",
    d: "M-121.4-332.2c0-1.1,0.9-2,2-2h10.5c1.1,0,2,0.9,2,2v17.8c0,1.1-0.9,2-2,2h-10.5 c-1.1,0-2-0.9-2-2V-332.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_31_",
    x: -120.1,
    y: -353,
    className: "st4",
    width: 14.5,
    height: 14.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_30_",
    x: -141.9,
    y: -334.9,
    className: "st5",
    width: 5.5,
    height: 9.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_29_",
    x: -172.7,
    y: -329.5,
    className: "st6",
    width: 14.5,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_28_",
    x: -121.4,
    y: -329.5,
    className: "st6",
    width: 14.5,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_27_",
    x: -158.2,
    y: -321,
    className: "st7",
    width: 36.8,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_26_",
    x: -158.2,
    y: -361.1,
    className: "st7",
    width: 38.1,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_25_",
    x: -158.2,
    y: -329.5,
    className: "st8",
    width: 36.8,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_24_",
    x: -158.2,
    y: -349.5,
    className: "st8",
    width: 38.1,
    height: 7.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_22_",
    className: "st4",
    d: "M-175.7-338.6h73.8v9.1c0,1.1-0.9,2-2,2h-69.8c-1.1,0-2-0.9-2-2V-338.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_19_",
    className: "st2",
    d: "M-146.9-346.4h14.9c1.7,0,3,1.3,3,3v12.2c0,1.7-1.3,3-3,3h-14.9c-1.7,0-3-1.3-3-3v-12.2 C-149.9-345-148.6-346.4-146.9-346.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_17_",
    className: "st3",
    d: "M-145.3-346.4h-1.7c-1.7,0-3,1.3-3,3v12.2c0,1.7,1.3,3,3,3h1c0.5,0,0.9-0.4,0.9-1l-0.3-12.7 V-346.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_15_",
    className: "st4",
    d: "M-146.9-341.9h14.9c1.7,0,3,1.3,3,3v11.9c0,1.7-1.3,3-3,3h-14.9c-1.7,0-3-1.3-3-3v-11.9 C-149.9-340.6-148.6-341.9-146.9-341.9z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_11_",
    className: "st9",
    cx: -139.8,
    cy: -335.1,
    rx: 3.9,
    ry: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_10_",
    className: "st9",
    d: "M-140.7-333.2c0.4-0.7,1.4-0.7,1.8,0l1.8,3.6c0.3,0.7-0.2,1.5-0.9,1.5h-3.6 c-0.7,0-1.2-0.8-0.9-1.5L-140.7-333.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9_",
    className: "st3",
    d: "M-120.1-368.4l14.5-3.5v8l-14.5,3.5V-368.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_8_",
    x: -158.4,
    y: -342.4,
    className: "st3",
    width: 8.4,
    height: 3.8
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_280_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_308_",
    className: "st0",
    d: "M13-308.8h72c2.2,0,4,1.8,4,4v32c0,2.2-1.8,4-4,4H13c-2.2,0-4-1.8-4-4v-32 C9-307,10.8-308.8,13-308.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_307_",
    className: "st1",
    d: "M17.4-307c0-5.5,4.5-10,10-10h42.4c5.5,0,10,4.5,10,10v26.6c0,2.2-1.8,4-4,4H21.4 c-2.2,0-4-1.8-4-4V-307z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_306_",
    className: "st1",
    d: "M15.3-321.5c0-5.5,4.5-10,10-10h47.1c5.5,0,10,4.5,10,10v29.8H15.3V-321.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_305_",
    x: 12.3,
    y: -304,
    className: "st2",
    width: 73.8,
    height: 11.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_304_",
    className: "st2",
    d: "M76.2-321.3h7.9c1.1,0,2,0.9,2,2v18.3h-9.9V-321.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_303_",
    className: "st2",
    d: "M12.3-319.3c0-1.1,0.9-2,2-2h6.4c1.1,0,2,0.9,2,2v16.3c0,1.1-0.9,2-2,2h-6.4c-1.1,0-2-0.9-2-2 V-319.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_302_",
    className: "st2",
    d: "M15.3-332.7c0-1.1,0.9-2,2-2h10.5c1.1,0,2,0.9,2,2v20.5H15.3V-332.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_301_",
    className: "st2",
    d: "M67.9-332.7c0-1.1,0.9-2,2-2h10.5c1.1,0,2,0.9,2,2v20.5H67.9V-332.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_300_",
    className: "st3",
    d: "M15.4-322.6l14.3-3.6v12.6l-14.3-0.2V-322.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_299_",
    className: "st4",
    d: "M15.3-315h14.5v14.5H15.3V-315z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_298_",
    className: "st4",
    d: "M15.3-294.2c0-1.1,0.9-2,2-2h10.5c1.1,0,2,0.9,2,2v17.8c0,1.1-0.9,2-2,2H17.3 c-1.1,0-2-0.9-2-2V-294.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_297_",
    className: "st4",
    d: "M66.6-294.2c0-1.1,0.9-2,2-2h10.5c1.1,0,2,0.9,2,2v17.8c0,1.1-0.9,2-2,2H68.6 c-1.1,0-2-0.9-2-2V-294.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_296_",
    x: 67.9,
    y: -315,
    className: "st4",
    width: 14.5,
    height: 14.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_295_",
    x: 46.1,
    y: -296.8,
    className: "st5",
    width: 5.5,
    height: 9.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_294_",
    x: 15.3,
    y: -291.4,
    className: "st6",
    width: 14.5,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_293_",
    x: 66.6,
    y: -291.4,
    className: "st6",
    width: 14.5,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_292_",
    x: 29.8,
    y: -282.9,
    className: "st7",
    width: 36.8,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_291_",
    x: 29.8,
    y: -323.1,
    className: "st7",
    width: 38.1,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_290_",
    x: 29.8,
    y: -291.4,
    className: "st8",
    width: 36.8,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_289_",
    x: 29.8,
    y: -311.4,
    className: "st8",
    width: 38.1,
    height: 7.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_288_",
    className: "st4",
    d: "M12.3-300.5h73.8v9.1c0,1.1-0.9,2-2,2H14.3c-1.1,0-2-0.9-2-2V-300.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_287_",
    className: "st2",
    d: "M41.1-308.4H56c1.7,0,3,1.3,3,3v12.2c0,1.7-1.3,3-3,3H41.1c-1.7,0-3-1.3-3-3v-12.2 C38.1-307,39.4-308.4,41.1-308.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_286_",
    className: "st3",
    d: "M42.7-308.4h-1.7c-1.7,0-3,1.3-3,3v12.2c0,1.7,1.3,3,3,3h1c0.5,0,0.9-0.4,0.9-1l-0.3-12.7 V-308.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_285_",
    className: "st4",
    d: "M41.1-303.9H56c1.7,0,3,1.3,3,3v11.9c0,1.7-1.3,3-3,3H41.1c-1.7,0-3-1.3-3-3v-11.9 C38.1-302.5,39.4-303.9,41.1-303.9z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_284_",
    className: "st9",
    cx: 48.2,
    cy: -297,
    rx: 3.9,
    ry: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_283_",
    className: "st9",
    d: "M47.3-295.1c0.4-0.7,1.4-0.7,1.8,0l1.8,3.6c0.3,0.7-0.2,1.5-0.9,1.5h-3.6 c-0.7,0-1.2-0.8-0.9-1.5L47.3-295.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_282_",
    className: "st3",
    d: "M67.9-330.4l14.5-3.5v8l-14.5,3.5V-330.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_281_",
    x: 29.6,
    y: -304.4,
    className: "st3",
    width: 8.4,
    height: 3.8
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_145_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_72_",
    className: "st0",
    d: "M-173.6-230.5h72c2.2,0,4,1.8,4,4v32c0,2.2-1.8,4-4,4h-72c-2.2,0-4-1.8-4-4v-32 C-177.6-228.7-175.8-230.5-173.6-230.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_71_",
    className: "st10",
    d: "M-169.2-228.7c0-5.5,4.5-10,10-10h42.4c5.5,0,10,4.5,10,10v26.6c0,2.2-1.8,4-4,4h-54.5 c-2.2,0-4-1.8-4-4V-228.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_70_",
    className: "st11",
    d: "M-171.4-243.2c0-5.5,4.5-10,10-10h47.1c5.5,0,10,4.5,10,10v29.8h-67.2V-243.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_69_",
    x: -174.4,
    y: -225.7,
    className: "st12",
    width: 73.8,
    height: 11.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_68_",
    className: "st13",
    d: "M-110.5-243h7.9c1.1,0,2,0.9,2,2v18.3h-9.9V-243z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_67_",
    className: "st13",
    d: "M-174.4-241c0-1.1,0.9-2,2-2h6.4c1.1,0,2,0.9,2,2v16.3c0,1.1-0.9,2-2,2h-6.4c-1.1,0-2-0.9-2-2 V-241z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_66_",
    className: "st14",
    d: "M-171.4-254.5c0-1.1,0.9-2,2-2h10.5c1.1,0,2,0.9,2,2v20.5h-14.5V-254.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_65_",
    className: "st14",
    d: "M-118.7-254.5c0-1.1,0.9-2,2-2h10.5c1.1,0,2,0.9,2,2v20.5h-14.5V-254.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_64_",
    className: "st15",
    d: "M-171.2-244.3l14.3-3.6v12.6l-14.3-0.2V-244.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_63_",
    className: "st16",
    d: "M-171.4-236.7h14.5v14.5h-14.5V-236.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_62_",
    className: "st17",
    d: "M-171.4-215.9c0-1.1,0.9-2,2-2h10.5c1.1,0,2,0.9,2,2v17.8c0,1.1-0.9,2-2,2h-10.5 c-1.1,0-2-0.9-2-2V-215.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_61_",
    className: "st17",
    d: "M-120.1-215.9c0-1.1,0.9-2,2-2h10.5c1.1,0,2,0.9,2,2v17.8c0,1.1-0.9,2-2,2H-118 c-1.1,0-2-0.9-2-2V-215.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_60_",
    x: -118.7,
    y: -236.7,
    className: "st16",
    width: 14.5,
    height: 14.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_59_",
    x: -140.5,
    y: -218.6,
    className: "st5",
    width: 5.5,
    height: 9.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_58_",
    x: -171.4,
    y: -213.2,
    className: "st18",
    width: 14.5,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_57_",
    x: -120.1,
    y: -213.2,
    className: "st18",
    width: 14.5,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_56_",
    x: -156.8,
    y: -204.7,
    className: "st19",
    width: 36.8,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_55_",
    x: -156.8,
    y: -244.8,
    className: "st20",
    width: 38.1,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_54_",
    x: -156.8,
    y: -213.2,
    className: "st21",
    width: 36.8,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_53_",
    x: -156.8,
    y: -233.2,
    className: "st22",
    width: 38.1,
    height: 7.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_52_",
    className: "st16",
    d: "M-174.4-222.3h73.8v9.1c0,1.1-0.9,2-2,2h-69.8c-1.1,0-2-0.9-2-2V-222.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_51_",
    className: "st12",
    d: "M-145.6-230.1h14.9c1.7,0,3,1.3,3,3v12.2c0,1.7-1.3,3-3,3h-14.9c-1.7,0-3-1.3-3-3v-12.2 C-148.6-228.7-147.2-230.1-145.6-230.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_50_",
    className: "st15",
    d: "M-143.9-230.1h-1.7c-1.7,0-3,1.3-3,3v12.2c0,1.7,1.3,3,3,3h1c0.5,0,0.9-0.4,0.9-1l-0.3-12.7 V-230.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_49_",
    className: "st16",
    d: "M-145.6-225.6h14.9c1.7,0,3,1.3,3,3v11.9c0,1.7-1.3,3-3,3h-14.9c-1.7,0-3-1.3-3-3v-11.9 C-148.6-224.3-147.2-225.6-145.6-225.6z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_48_",
    className: "st23",
    cx: -138.4,
    cy: -218.8,
    rx: 3.9,
    ry: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_47_",
    className: "st23",
    d: "M-139.3-216.9c0.4-0.7,1.4-0.7,1.8,0l1.8,3.6c0.3,0.7-0.2,1.5-0.9,1.5h-3.6 c-0.7,0-1.2-0.8-0.9-1.5L-139.3-216.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_46_",
    className: "st15",
    d: "M-118.7-252.1l14.5-3.5v8l-14.5,3.5V-252.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_45_",
    x: -157,
    y: -226.1,
    className: "st15",
    width: 8.4,
    height: 3.8
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_387_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_467_",
    className: "st0",
    d: "M15-221.2h72c2.2,0,4,1.8,4,4v32c0,2.2-1.8,4-4,4H15c-2.2,0-4-1.8-4-4v-32 C11-219.4,12.8-221.2,15-221.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_464_",
    className: "st10",
    d: "M19.4-219.4c0-5.5,4.5-10,10-10h42.4c5.5,0,10,4.5,10,10v26.6c0,2.2-1.8,4-4,4H23.4 c-2.2,0-4-1.8-4-4V-219.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_461_",
    className: "st11",
    d: "M17.3-233.9c0-5.5,4.5-10,10-10h47.1c5.5,0,10,4.5,10,10v29.8H17.3V-233.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_458_",
    x: 14.2,
    y: -216.4,
    className: "st12",
    width: 73.8,
    height: 11.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_455_",
    className: "st13",
    d: "M78.2-233.7H86c1.1,0,2,0.9,2,2v18.3h-9.9V-233.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_452_",
    className: "st13",
    d: "M14.2-231.7c0-1.1,0.9-2,2-2h6.4c1.1,0,2,0.9,2,2v16.3c0,1.1-0.9,2-2,2h-6.4 c-1.1,0-2-0.9-2-2V-231.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_449_",
    className: "st14",
    d: "M17.3-245.2c0-1.1,0.9-2,2-2h10.5c1.1,0,2,0.9,2,2v20.5H17.3V-245.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_446_",
    className: "st14",
    d: "M69.9-245.2c0-1.1,0.9-2,2-2h10.5c1.1,0,2,0.9,2,2v20.5H69.9V-245.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_443_",
    className: "st15",
    d: "M17.4-235l14.3-3.6v12.6l-14.3-0.2V-235z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_440_",
    className: "st16",
    d: "M17.3-227.4h14.5v14.5H17.3V-227.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_437_",
    className: "st17",
    d: "M17.3-206.6c0-1.1,0.9-2,2-2h10.5c1.1,0,2,0.9,2,2v17.8c0,1.1-0.9,2-2,2H19.3 c-1.1,0-2-0.9-2-2V-206.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_434_",
    className: "st17",
    d: "M68.6-206.6c0-1.1,0.9-2,2-2h10.5c1.1,0,2,0.9,2,2v17.8c0,1.1-0.9,2-2,2H70.6 c-1.1,0-2-0.9-2-2V-206.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_431_",
    x: 69.9,
    y: -227.4,
    className: "st16",
    width: 14.5,
    height: 14.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_430_",
    x: 48.1,
    y: -209.3,
    className: "st5",
    width: 5.5,
    height: 9.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_427_",
    x: 17.3,
    y: -203.9,
    className: "st18",
    width: 14.5,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_424_",
    x: 68.6,
    y: -203.9,
    className: "st18",
    width: 14.5,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_421_",
    x: 31.8,
    y: -195.4,
    className: "st19",
    width: 36.8,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_418_",
    x: 31.8,
    y: -235.5,
    className: "st20",
    width: 38.1,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_415_",
    x: 31.8,
    y: -203.9,
    className: "st21",
    width: 36.8,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_412_",
    x: 31.8,
    y: -223.9,
    className: "st22",
    width: 38.1,
    height: 7.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_409_",
    className: "st16",
    d: "M14.2-213h73.8v9.1c0,1.1-0.9,2-2,2H16.2c-1.1,0-2-0.9-2-2V-213z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_406_",
    className: "st12",
    d: "M43.1-220.8H58c1.7,0,3,1.3,3,3v12.2c0,1.7-1.3,3-3,3H43.1c-1.7,0-3-1.3-3-3v-12.2 C40.1-219.4,41.4-220.8,43.1-220.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_403_",
    className: "st15",
    d: "M44.7-220.8h-1.7c-1.7,0-3,1.3-3,3v12.2c0,1.7,1.3,3,3,3h1c0.5,0,0.9-0.4,0.9-1l-0.3-12.7 V-220.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_400_",
    className: "st16",
    d: "M43.1-216.3H58c1.7,0,3,1.3,3,3v11.9c0,1.7-1.3,3-3,3H43.1c-1.7,0-3-1.3-3-3v-11.9 C40.1-215,41.4-216.3,43.1-216.3z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_397_",
    className: "st23",
    cx: 50.2,
    cy: -209.5,
    rx: 3.9,
    ry: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_394_",
    className: "st23",
    d: "M49.3-207.6c0.4-0.7,1.4-0.7,1.8,0l1.8,3.6c0.3,0.7-0.2,1.5-0.9,1.5h-3.6 c-0.7,0-1.2-0.8-0.9-1.5L49.3-207.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_391_",
    className: "st15",
    d: "M69.9-242.8l14.5-3.5v8l-14.5,3.5V-242.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_388_",
    x: 31.6,
    y: -216.8,
    className: "st15",
    width: 8.4,
    height: 3.8
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_7_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_144_",
    className: "st24",
    d: "M-187.1-109.9h72c2.2,0,4,1.8,4,4v32c0,2.2-1.8,4-4,4h-72c-2.2,0-4-1.8-4-4v-32 C-191.1-108.1-189.3-109.9-187.1-109.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_143_",
    className: "st25",
    d: "M-181.6-109.7c0-5.5,4.5-10,10-10h42.4c5.5,0,10,4.5,10,10v26.6c0,2.2-1.8,4-4,4h-54.5 c-2.2,0-4-1.8-4-4V-109.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_142_",
    className: "st25",
    d: "M-183.8-124.2c0-5.5,4.5-10,10-10h46.1c5.5,0,10,4.5,10,10v29.8h-66.1V-124.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_141_",
    className: "st26",
    d: "M-183.8-96.9c0-1.1,0.9-2,2-2h10.5c1.1,0,2,0.9,2,2v17.8c0,1.1-0.9,2-2,2h-10.5 c-1.1,0-2-0.9-2-2V-96.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_140_",
    className: "st26",
    d: "M-132.5-96.9c0-1.1,0.9-2,2-2h10.5c1.1,0,2,0.9,2,2v17.8c0,1.1-0.9,2-2,2h-10.5 c-1.1,0-2-0.9-2-2V-96.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_139_",
    x: -169.3,
    y: -85.6,
    className: "st27",
    width: 36.8,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_138_",
    x: -183.8,
    y: -134.2,
    className: "st28",
    width: 66.1,
    height: 41.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_137_",
    x: -183.8,
    y: -155.8,
    className: "st25",
    width: 65.8,
    height: 25.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_136_",
    x: -183.8,
    y: -98,
    className: "st29",
    width: 66.1,
    height: 5.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_135_",
    x: -123.3,
    y: -135.5,
    className: "st29",
    width: 5.6,
    height: 42.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_134_",
    x: -183.8,
    y: -135.5,
    className: "st29",
    width: 5.6,
    height: 42.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_132_",
    x: -183.8,
    y: -126.3,
    className: "st26",
    width: 5.6,
    height: 8.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_80_",
    x: -123.3,
    y: -126.3,
    className: "st26",
    width: 5.6,
    height: 8.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_79_",
    className: "st29",
    d: "M-183.8-156.9c0-1.1,0.9-2,2-2h10.5c1.1,0,2,0.9,2,2v16.1h37.5v-16.1c0-1.1,0.9-2,2-2h10.5 c1.1,0,2,0.9,2,2v16.1h0.9c1.1,0,2,0.9,2,2v10.5c0,1.1-0.9,2-2,2h-69.1c-1.1,0-2-0.9-2-2v-10.5c0-1.1,0.9-2,2-2h1.7V-156.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_78_",
    className: "st30",
    d: "M-114.6-139.7l-46.3,13.4h-24.6c-1.1,0-2-0.9-2-2v-10.5c0-1.1,0.9-2,2-2h1.7v-3l14.5-4.2v7.2 h37.5v-16.1c0-1.1,0.9-2,2-2h10.5c1.1,0,2,0.9,2,2v16.1h0.9C-115.6-140.8-114.9-140.3-114.6-139.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_77_",
    x: -178.2,
    y: -112.9,
    className: "st31",
    width: 55,
    height: 15
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_76_",
    className: "st29",
    d: "M-157.3-143.5h14.9c1.7,0,3,1.3,3,3v13.5c0,1.7-1.3,3-3,3h-14.9c-1.7,0-3-1.3-3-3v-13.5 C-160.3-142.2-159-143.5-157.3-143.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_75_",
    className: "st30",
    d: "M-139.4-136.2l-20.9,6.1v-10.3c0-1.7,1.3-3,3-3h14.9c1.7,0,3,1.3,3,3V-136.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_74_",
    className: "st32",
    d: "M-148.3-132.7c1.4-0.5,2.4-1.8,2.4-3.3c0-2-1.8-3.5-3.9-3.5c-2.2,0-3.9,1.6-3.9,3.5 c0,1.5,1,2.7,2.4,3.3l-1.1,2.2c-0.3,0.7,0.2,1.5,0.9,1.5h3.6c0.7,0,1.2-0.8,0.9-1.5L-148.3-132.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_73_",
    x: -131.8,
    y: -142.7,
    className: "st29",
    width: 14.5,
    height: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_44_",
    x: -183.8,
    y: -142.7,
    className: "st29",
    width: 14.5,
    height: 1.9
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_585_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_606_",
    className: "st24",
    d: "M10.2-98.6h72c2.2,0,4,1.8,4,4v32c0,2.2-1.8,4-4,4h-72c-2.2,0-4-1.8-4-4v-32 C6.2-96.8,8-98.6,10.2-98.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_605_",
    className: "st25",
    d: "M15.7-98.5c0-5.5,4.5-10,10-10h42.4c5.5,0,10,4.5,10,10v26.6c0,2.2-1.8,4-4,4H19.7 c-2.2,0-4-1.8-4-4V-98.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_604_",
    className: "st25",
    d: "M13.5-113c0-5.5,4.5-10,10-10h46.1c5.5,0,10,4.5,10,10v29.8H13.5V-113z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_603_",
    className: "st26",
    d: "M13.5-85.7c0-1.1,0.9-2,2-2H26c1.1,0,2,0.9,2,2v17.8c0,1.1-0.9,2-2,2H15.5c-1.1,0-2-0.9-2-2 V-85.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_602_",
    className: "st26",
    d: "M64.8-85.7c0-1.1,0.9-2,2-2h10.5c1.1,0,2,0.9,2,2v17.8c0,1.1-0.9,2-2,2H66.8 c-1.1,0-2-0.9-2-2V-85.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_601_",
    x: 28,
    y: -74.4,
    className: "st27",
    width: 36.8,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_600_",
    x: 13.5,
    y: -123,
    className: "st28",
    width: 66.1,
    height: 41.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_599_",
    x: 13.5,
    y: -144.6,
    className: "st25",
    width: 65.8,
    height: 25.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_598_",
    x: 13.5,
    y: -86.7,
    className: "st29",
    width: 66.1,
    height: 5.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_597_",
    x: 74,
    y: -124.2,
    className: "st29",
    width: 5.6,
    height: 42.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_596_",
    x: 13.5,
    y: -124.2,
    className: "st29",
    width: 5.6,
    height: 42.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_595_",
    x: 13.5,
    y: -115,
    className: "st26",
    width: 5.6,
    height: 8.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_594_",
    x: 74,
    y: -115,
    className: "st26",
    width: 5.6,
    height: 8.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_593_",
    className: "st29",
    d: "M13.5-145.6c0-1.1,0.9-2,2-2H26c1.1,0,2,0.9,2,2v16.1h37.5v-16.1c0-1.1,0.9-2,2-2H78 c1.1,0,2,0.9,2,2v16.1h0.9c1.1,0,2,0.9,2,2v10.5c0,1.1-0.9,2-2,2H11.8c-1.1,0-2-0.9-2-2v-10.5c0-1.1,0.9-2,2-2h1.7V-145.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_592_",
    className: "st30",
    d: "M82.7-128.4L36.4-115H11.8c-1.1,0-2-0.9-2-2v-10.5c0-1.1,0.9-2,2-2h1.7v-3l14.5-4.2v7.2h37.5 v-16.1c0-1.1,0.9-2,2-2H78c1.1,0,2,0.9,2,2v16.1h0.9C81.7-129.5,82.4-129.1,82.7-128.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_591_",
    x: 19.1,
    y: -101.7,
    className: "st31",
    width: 55,
    height: 15
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_590_",
    className: "st29",
    d: "M40-132.3h14.9c1.7,0,3,1.3,3,3v13.5c0,1.7-1.3,3-3,3H40c-1.7,0-3-1.3-3-3v-13.5 C37-130.9,38.3-132.3,40-132.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_589_",
    className: "st30",
    d: "M57.9-125L37-118.9v-10.3c0-1.7,1.3-3,3-3h14.9c1.7,0,3,1.3,3,3V-125z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_588_",
    className: "st32",
    d: "M49-121.4c1.4-0.5,2.4-1.8,2.4-3.3c0-2-1.8-3.5-3.9-3.5s-3.9,1.6-3.9,3.5 c0,1.5,1,2.7,2.4,3.3l-1.1,2.2c-0.3,0.7,0.2,1.5,0.9,1.5h3.6c0.7,0,1.2-0.8,0.9-1.5L49-121.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_587_",
    x: 65.5,
    y: -131.4,
    className: "st29",
    width: 14.5,
    height: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_586_",
    x: 13.5,
    y: -131.4,
    className: "st29",
    width: 14.5,
    height: 1.9
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_4_",
    className: "st33",
    cx: 54.3,
    cy: -414,
    rx: 34.7,
    ry: 27.7
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_5_",
    className: "st33",
    points: "19.7,-414 19.7,-422.6 34.7,-418.1 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_6_",
    className: "st33",
    points: "89,-414 89,-422 77.2,-422 "
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_1_",
    className: "st1",
    cx: 54.3,
    cy: -422,
    rx: 34.7,
    ry: 27.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_148_",
    className: "st34"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: 39.3,
    y: -436,
    className: "st34",
    width: 30,
    height: 28
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_149_",
    className: "st35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_150_",
    className: "st36",
    d: "M52.1-434.6c0.9-1.9,3.6-1.9,4.5,0l2.6,5.4c0.4,0.8,1.1,1.3,2,1.4l6,0.7 c2.1,0.2,3,2.9,1.4,4.3l-4.3,3.8c-0.7,0.6-1,1.5-0.8,2.4l1.1,5.6c0.4,2.1-1.8,3.7-3.6,2.7l-5.4-2.9c-0.7-0.4-1.6-0.4-2.4,0 l-5.4,2.9c-1.9,1-4-0.6-3.6-2.7l1.1-5.6c0.2-0.9-0.1-1.8-0.8-2.4l-4.3-3.8c-1.6-1.4-0.8-4.1,1.4-4.3l6-0.7c0.8-0.1,1.6-0.6,2-1.4 L52.1-434.6z"
  })))), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_158_",
    className: "st37",
    cx: -304.7,
    cy: -175.9,
    rx: 34.7,
    ry: 27.7
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_157_",
    className: "st37",
    points: "-339.3,-175.9 -339.3,-184.5 -324.3,-180 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_154_",
    className: "st37",
    points: "-270,-175.9 -270,-183.9 -281.8,-183.9 "
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_151_",
    className: "st38",
    cx: -304.7,
    cy: -183.9,
    rx: 34.7,
    ry: 27.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_21_"
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: -319.7,
    y: -197.9,
    width: 30,
    height: 28
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_23_",
    className: "st39"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_147_",
    className: "st36",
    d: "M-306.9-196.5c0.9-1.9,3.6-1.9,4.5,0l2.6,5.4c0.4,0.8,1.1,1.3,2,1.4l6,0.7 c2.1,0.2,3,2.9,1.4,4.3l-4.3,3.8c-0.7,0.6-1,1.5-0.8,2.4l1.1,5.6c0.4,2.1-1.8,3.7-3.6,2.7l-5.4-2.9c-0.7-0.4-1.6-0.4-2.4,0 l-5.4,2.9c-1.9,1-4-0.6-3.6-2.7l1.1-5.6c0.2-0.9-0.1-1.8-0.8-2.4l-4.3-3.8c-1.6-1.4-0.8-4.1,1.4-4.3l6-0.7c0.8-0.1,1.6-0.6,2-1.4 L-306.9-196.5z"
  })))), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_695_",
    className: "st37",
    cx: -299.7,
    cy: -90.3,
    rx: 34.7,
    ry: 27.7
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_694_",
    className: "st37",
    points: "-334.3,-90.3 -334.3,-98.9 -319.3,-94.4 "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_691_",
    className: "st37",
    points: "-265,-90.3 -265,-98.3 -276.8,-98.3 "
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_688_",
    className: "st38",
    cx: -299.7,
    cy: -98.3,
    rx: 34.7,
    ry: 27.7
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_684_",
    className: "st40",
    points: "-308.7,-99.3 -302.4,-92.9 -290.7,-103.8 "
  })), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 147,
    height: 137,
    id: "XMLID_686_",
    xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEASABIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAPmAAAGAQAACjH/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAIoAlAMBIgACEQEDEQH/ xADHAAEAAwEBAQAAAAAAAAAAAAAAAwQGBQIBAQEAAwEBAQAAAAAAAAAAAAAAAgMEAQUGEAACAQMD AwMDAwUAAAAAAAABAgMABAUQERMSRDUgMAYhMRRAIxUiM0MkNBEAAQICARIDBQgDAAAAAAAAAQAC EQMhECAxQVFhcRIiMpKywjNzgwRFkbFSgdETI0QwQKHB4UJiNXJTFBIAAQIDBQYFBAMAAAAAAAAA AQACESExECBREgMwQXGBkSJh0eEyE7HBQmLxUnL/2gAMAwEAAhEDEQAAAM3VnqShIjEiMSIxIjEi MSIxIjEiMWngSVLdQEvEVrvdPzs/Btdj1jr5EfcjhzN8zafNE8K0PA9PR5F0gJwSVLdQk11HteNl S/WSseRC+wj8l9pdg5nag73B/OzxvoNgWSnBJWs+Y82FqvZ+bwj5PvurqYNVuf0qxosp8SWHFT8h fM1VTH7nDerpD0r5wSePcUebWxSsfN4ZYDnLOoyk2y7R53zGIHzHSHOeMPscd62oPSvnBJVtVDVd DM9rwsd2erLlrnePs5fYHyEQ5x481pyp565T93YGic4JKluoO3xFUdbJnut5OboeqbPC95puLMUd aztnj16fpaA3WgTgkqW6gABYsc9XHpeKCKaEtkHQAE4JKmxhMo1YyjVjKNWMo1YyjVjKNWMtb2t2 qOE+bxTDCN8nL//aAAgBAgABBQD2yQBNkgC13ctX5FwtRZKVaguI5h6L65MjgbaEkkLtSu0TwyiW PRzsi/U09kxitbVYVuJRJITvWLY9Gkn1Qf0knerW5aGrm5MpJ30xY2XW5gKSD6HcUTvoqb1aRGOL WaFZVmtpI66BXGKSIsbez6T6mgiahbQigoUe2/PW15v/ALVf/9oACAEDAAEFAPbJ2p56MkhrrcUs 7CkdWHomcsQNPvW1AlSjBl0J2A0aAlIoggkcMxNW5+mjfb7EmopSlSSl6J0tx9NZE2I+lb0ToBUa 9K6soYNGRXSK6aC70kW3rKKa41oAD3D11+7X7lf/2gAIAQEAAQUAys0wynPPXPPXPPXPPXPPXPPX PPXPPXPPXPPXPPXPPXPPXPPXPPXPPXPPXPN+FlfKfoeyyvlPRbYy8uqh+NGk+PWC1/A42n+O2LVP 8blWriyurY+rssr5TS3tprmSwwdvbBVoRGhEtcSVIoU0yK65DAI4dHjb0dllfKVb28lzNY2MVlCk e9AAau/SCSSASRGuzoVrLYtLyNlZW17LK+UrAWQigjTqOruFBJJRGduJotCN6delvkNkI5Neyyvl IkMkkaCONBsuixTOrdXVFE8r43Gx2aZsR8FO4UEknKQiex17LK+UxwBv9WYKMU8b2OUxIuaxuNSz S7u47WO4uJLiRmCgkk1KAY9eyyvlMedr0Up3VmChmLGwvZrSaCeO4ju7uO1juLiS4kZgoJLHSY7Q 69llfKWjBbq3fqRJOkMxYgElECiG4mgMs0szMwUMxY630gEevZZXygOxtLjriRg60igDRmChmLHW WQIuVn47XXssr5SsPeBGR2QpKr0rlaEqmjIuzMWOsk6rTMTWSu/yZ9eyyvlKBIOPySyilndaW5Q0 JozXWlGaIU1ytPM70SAMlkhIPR2WV8pp9qtMtLFUF5bzj03GRtoBd5Ke59XZZXynoBIqO/u4qXNX Qr+buKfM3bVLeXMvsdllfKfoeyyvlPdSOSQx4fIyUPj2QNN8fyAr+HyP4t7/ANvu47+1r/j/AP/a AAgBAgIGPwDZkkwA3lZdEZv2dTkF7yOElH5X9YrvA1B0KiwzFWmounSaexhn4m5OqD2GBCa8b6jA 2uODSUSbG6jHZyRmy+S+XVhmhGf4+qLwIClmo3BwPX+LXD9SiDZldFzDuw4KHtYN3nbqHEt+9wt5 t4KarbEoRq7uNyDqihwXc3M3+wpZVQY0uKD9SbtzcL82NPJexqg0AcNp2fGP9RKrp9PVV0aYGq// 2gAIAQMCBj8A2c1Boj4qq9xU+5Su5RQXJqIQItJtDmmMowWd9foiRY4WnhbAzCwFp5XIdFO7xuQK mI2yEVF1+YCoFLaShzVW9F+K/9oACAEBAQY/AOsAmOAE+bARPrct47SK3jtIreO0it47SK3jtIre O0it47SK3jtIreO0it47SK3jtIreO0it47SK3jtIreO0it47SK3jtIqPxHb31H0rrePN13fcubsr rePN13VsZcshvqdQFGfO9jB+ZWVjOwmHkt2dJ3vWSXswGPmoyJod/Fwh+KhOllo9VkeNfzdldbx5 uu6qJUluM4+AwoPnQmzb+aMAUGhUmFSwqKha8BzTZBRmdJkusmXaOC4ix4LXNoINbzdldbx5uu6o 2TKEXOKDGCLjnvtkqJsKAq31EqAUD4q8i+WAJ7Rkn1Xii1wg4GBBu1nN2V1vHm67qn/S8fMm5t5v 6qJsCsvqJQa0Ek2AFiuaWuviFWCb1TBBsyh/+V2s5uyut483XcmsFlxA8U2W2w0AD2ICqTLlufC4 Io41BtgoS5YxnOoACxnQdOdnOuXgmkw+JjZN2/UvqJU5lsNxm4RTWc3ZXW8ebruXTg/7G+dbLLIR GdC7G2vjSABOti05Yzsqc7OdcvBY76Sc1tslGZMMSbAtAK+omo8G4fKs5uyut483XcpBuPb5qKBU SolBzKWnPZaIQmSzEGyLhWO+knNbbJRmTDEmwLQCiVE1Xn+JrObsrrePN13KU42njzWKbLfJQsqJ UAr6JlPLY2YLGmuLjfUSomscLQBJ8Kzm7K63jzddyBFpS5zbYp/NRFSNs1YlRNZfNgJ8TlTMke2z Wc3ZXW8ebruqHp3nJdSw37iiPaFRQbivKmhWYqJrIClyLnHCVBp+Wyht+/Wc3ZXW8ebruqRFkISp xhMFAcf3VKcoX1SCFQ5Zw8VnLJBOFUmAuBRNAFkoyJBybDn3bwrebsrrePN13VgZO+Yy7+4L5bxH 0mg10C7Gd6W0rFGRL9It4a7m7K63jzdd1bEUKDZhhcNI/FUhrsI9y3bPx96ycVuAe9ZcwkXI0fYc 3ZXW8ebru+5c3ZXW8ebru+2xZbS43GiKiJJaLriAv2DC4+5WGHA79FifCp+JGMRCGKuo/pN6/ebz OOf/ACursK7CuwrsK7CuwrsK7CuwrsK7CuwrsKH9XybC+hX0K+hX0Vn2WF//2Q==",
    transform: "matrix(1 0 0 1 -531.6667 -149.6512)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_690_",
    className: "st41",
    d: "M-292.8-116.9c1-0.9,0.5-2.6-0.8-2.9c-1.9-0.3-4-0.5-6-0.5c-15.2,0-27.6,9.9-27.6,22 c0,2.8,0.7,5.5,1.9,7.9c0.5,1,1.8,1.3,2.6,0.5L-292.8-116.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_687_",
    className: "st41",
    d: "M-274.5-107.3c-1.1-2-2.6-3.8-4.3-5.4c-1-0.9-2.4-0.9-3.5-0.1L-316.4-85 c-1.4,1.2-1.3,3.4,0.3,4.4c3.2,1.9,7,3.3,11.1,3.9c0.8,0.1,1.6-0.2,2.2-0.7l27.8-26.7C-274.1-105-273.9-106.3-274.5-107.3z"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_883_",
    className: "st38",
    cx: 34.7,
    cy: 35.7,
    rx: 34.7,
    ry: 27.7
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_882_",
    className: "st40",
    points: "25.7,34.7 31.9,41.1 43.7,30.2 "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_879_",
    className: "st41",
    d: "M41.5,17.1c1-0.9,0.5-2.6-0.8-2.9c-1.9-0.3-4-0.5-6-0.5c-15.2,0-27.6,9.9-27.6,22 c0,2.8,0.7,5.5,1.9,7.9c0.5,1,1.8,1.3,2.6,0.5L41.5,17.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_876_",
    className: "st41",
    d: "M59.8,26.7c-1.1-2-2.6-3.8-4.3-5.4c-1-0.9-2.4-0.9-3.5-0.1L18,49c-1.4,1.2-1.3,3.4,0.3,4.4 c3.2,1.9,7,3.3,11.1,3.9c0.8,0.1,1.6-0.2,2.2-0.7l27.8-26.7C60.2,29,60.4,27.7,59.8,26.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonCompletedDown);
export default __webpack_public_path__ + "static/media/button_completed_down.3ddb66707ec10f624a0e79f37f701700.svg";
export { ForwardRef as ReactComponent };